import React from 'react';
import ReportingFinancesTaxWithholdingPage from '../components/ReportingFinancesTaxWithholdingPage';

const ReportingFinancesTaxWithholdingApp = (props) => (
  <ReportingFinancesTaxWithholdingPage {...props} />
);

export default ReportingFinancesTaxWithholdingApp;
